(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('[grid-recommendation]');

          if (recommendations && recommendations.children.length > 0) {

            const grid = this.querySelector('[grid-recommendation]');

            grid.innerHTML = recommendations.innerHTML;

            const count = recommendations.children.length;

            /*
             * Initialize Swiper AFTER
             * recommendation products are inserted.
             */
            const slider = this.querySelector('.productSlider');

            if (
              slider &&
              typeof Swiper !== 'undefined' &&
              slider.classList.contains('swiper')
            ) {

              const section = this.closest('[data-section-type="product-slider"]');

              const showMobile = parseInt(
                section?.dataset.showMobile || '2'
              );

              const showDesktop = parseInt(
                section?.dataset.showExtraLarge || '4'
              );

              const autoplayEnabled =
                section?.dataset.autoplay === 'true';

              const autoplayTime =
                parseInt(section?.dataset.autoplayTime || '3000');

              new Swiper(slider, {
                slidesPerView: showMobile,
                spaceBetween: 10,

                loop: false,

                watchOverflow: true,

                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false
                },

                navigation: {
                  nextEl: this.querySelector(
                    '.swiper-button-next'
                  ),
                  prevEl: this.querySelector(
                    '.swiper-button-prev'
                  )
                },

                pagination: {
                  el: this.querySelector(
                    '.swiper-pagination'
                  ),
                  clickable: true
                },

                breakpoints: {
                  750: {
                    slidesPerView: 3,
                    spaceBetween: 20
                  },

                  1200: {
                    slidesPerView: showDesktop,
                    spaceBetween: 30
                  }
                }
              });
            }

            /*
             * If only 1 or 2 products exist,
             * don't force unnecessary centering
             * when using Swiper.
             */
            if (
              count <= 2 &&
              !slider
            ) {
              grid.classList.add('recommendation-center');
            }

          } else {
            this.parentElement.remove();
          }

        })
        .catch(e => {
          console.error(
            'Product recommendations error:',
            e
          );
        });
    };

    new IntersectionObserver(
      handleIntersection.bind(this),
      {
        rootMargin: '0px 0px 200px 0px'
      }
    ).observe(this);
  }
}

customElements.define(
  'product-recommendations',
  ProductRecommendations
);

  } catch(e) { console.error(e); }
})();
})();
